<template>
    <div :class="['tab-content', classes]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                validator(v) {
                    return v === null || typeof v === 'string'
                }
            },

            classes: {
                type: String
            }
        },

        provide() {
            const tabs = {}

            Object.defineProperty(tabs, 'active', {
                enumerable: true,
                get: () => this.value
            })

            return { tabs }
        },
    }
</script>
